// 부계정(SUB) nav 권한 코드 보유 여부 — 본계정(MAIN)은 항상 허용 //
// 권한 없는 화면의 위젯/모달/버튼을 렌더하지 않아 서버 403(전역 알림 + /main 이동)을 애초에 막는다 //
export function hasNavCode(code) {
  if (window.sessionStorage.getItem('AccountType') !== 'SUB') return true;

  try {
    const codes = JSON.parse(window.sessionStorage.getItem('NavItems') || '[]');

    return codes.includes(code);
  }
  catch (e) {
    // 파싱 실패 시 기존 동작 유지 //
    return true;
  }
}

// 부계정(SUB) 여부 //
export function isSubAccount() {
  return window.sessionStorage.getItem('AccountType') === 'SUB';
}
